var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBriefs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    fill: "none",
    role: "img",
    "aria-label": "Computer and document",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00C6EA",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 36,
    height: 26,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 48h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 42v6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 28,
    width: 28,
    height: 28,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 38h12M42 44h12M42 50h8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBriefs);
export default __webpack_public_path__ + "static/media/icon-briefs.84fd76ac353f5d3b36f54ec98ce1ffbb.svg";
export { ForwardRef as ReactComponent };